import React from 'react';
import "./MailEditor.css";
import TextLabel from "../../../../Controls/TextLabel.mjs";
import WritenewIcon from "../../../../media/images/WritenewIcon.mjs";
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import MailsentIcon from "../../../../media/images/MailsentIcon.mjs";
import MailEditorFrom from "./fields/MailEditorFrom.mjs";
import MailEditorTo from "./fields/MailEditorTo.mjs";
import MailEditorCC from "./fields/MailEditorCC.mjs";
import MailEditorBCC from "./fields/MailEditorBCC.mjs";
import MailEditorSubject from "./fields/MailEditorSubject.mjs";
import MailEditorBody from "./fields/MailEditorBody.mjs";
import appLib from "../../../../libs/appLib.mjs";
import MailEditorAttach from "./fields/MailEditorAttach.mjs";

const G = window.glob;

const conf = confName => appLib.getConfigOption(confName).enabled;

const MailEditor = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false
		};
		this.toggleModal = this.toggleModal.bind(this);
		this.getMessage = this.getMessage.bind(this);
		this.setMessage = this.setMessage.bind(this);
		this.send = this.send.bind(this);
		this.uid = G.generateUid('MailEditor');
	}
	componentDidMount() {
		G.register('OpenMailEditor', received => {
			received = (received || {});
			received.keyValue = Math.random().toString();
			if ( received.message ) received.open = true;
			received.error = false;
			if ( typeof received.send !== 'function' ) received.send = null;
			if ( ! received.title ) received.title = null;
			if ( ! received.comment ) received.comment = null;
			if ( ! received.icon ) received.icon = <WritenewIcon />;
			this.setState(received);
		}, this.uid );
	}
	componentWillUnmount() {
		G.deregister( this.uid);
	}
	toggleModal() {
		this.setState({open: !this.state.open});
	}
	getMessage() {
		return this.state.message || {};
	}
	setMessage(m) {
		this.setState({ message: m, error: false });
	}
	async send() {
		const out = this.state.send ? (await this.state.send( this.state.message )) : (await appLib.sendMail( this.state.message ));
		if ( out?.error ) {
			await appLib.sound('error');
			if (out.field) this.setState( { error: out.field } );
		} else {
			await appLib.sound('sent');
			this.setState({open: false, message: null });
		}
	}
	render() {
		if ( ! this.state.open ) return '';
		const base = {
			message: this.state.message,
			getter: this.getMessage,
			setter: this.setMessage
		};
		return (
			<Modal
				fade={false}
				backdrop={'static'}
				keyboard={false}
				className={'MailEditor'}
				id={this.uid}
				size='xl'
				isOpen={this.state.open}
				toggle={this.toggleModal}
			>
				<ModalHeader toggle={this.toggleModal}>
					{ this.state.icon }
					{ this.state.title ?? <TextLabel value={"New Email"}/> }
				</ModalHeader>
				<ModalBody>
					{ this.state.comment ? (
						<div className={"mb-3 text-center fw-bold"}>
							{ this.state.comment }
						</div>
					) : '' }
					<Container className={"MailEditorFields"} fluid>
						<MailEditorFrom error={ this.state.error === 'from'} { ...base } />
						<MailEditorTo error={ this.state.error === 'to'} { ...base } />
						{
							conf("mailcc") && (
								<MailEditorCC error={ this.state.error === 'cc'} { ...base } />
							)
						}
						{
							conf("mailbcc") && (
								<MailEditorBCC error={ this.state.error === 'bcc'} { ...base } />
							)
						}
						<MailEditorSubject error={ this.state.error === 'subject'} { ...base } />
						<MailEditorBody error={ this.state.error === 'body'}  { ...base } />
						{
							conf("mailattach") && (
								<MailEditorAttach error={ this.state.error === 'attachments'}  { ...base } />
							)
						}
					</Container>
				</ModalBody>
				<ModalFooter>
					<Button
						className={"btn-icon"}
						color="warning"
						onClick={ (e)=>{
							e.preventDefault();
							this.setState({ open:false, message: {} });
						}}>
						<i>
							<TextLabel value={"cancel"} lang={"icon"} />
						</i>
						<b>
							<TextLabel value={"Cancel"}/>
						</b>
					</Button>
					<Button
						className={"btn-icon"}
						color="success"
						onClick={(e) => {
							e.preventDefault();
							this.send();
						}}>
						<b>
							<TextLabel value={"Send"}/>
						</b>
						<i>
							<MailsentIcon/>
						</i>
					</Button>
				</ModalFooter>
			</Modal>
		);
	}
}

export default MailEditor;